export default {"src":"/_next/static/media/arrow-left.12898d70.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};